<form [formGroup]="form" (ngSubmit)="signup()">
  <div class="container-inputs gap-3">
    <ng-container *ngFor="let control of formControls; let i = index">
      <div class="input-container">
        <div class="relative">
          <label [for]="control.name"></label>
          <input
            [id]="control.name"
            autocomplete="off"
            aria-label="submit-data"
            [ngClass]="control?.hasErr ? 'has-error' : ''"
            [class]="control.class ? control.class : 'input-without-icon'"
            [type]="control?.type ? control.type : 'text'"
            formControlName="{{ control.name }}"
            [placeholder]="control?.placeholder ? control.placeholder : ''"
            [readOnly]="control.disable"
          />

          <ng-container *ngFor="let icon of control?.icon">
            <span [class]="icon.placement">
              <ng-container *ngIf="icon.placement == 'left-icon'">
                <img
                  loading="lazy"
                  (click)="showPassClick(icon, i)"
                  [@rotatedState]="state"
                  [src]="icon.src"
                  [alt]="icon.alt"
                  width="20px"
                  height="15px"
                />
              </ng-container>

              <ng-container *ngIf="icon.placement == 'right-icon'">
                <img
                  [src]="icon.src"
                  [alt]="icon.alt"
                  loading="lazy"
                  width="20px"
                  height="15px"
                />
              </ng-container>
            </span>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <div>
      <!-- ==========[شماره موبایل]======== -->
      <div
        class="border-input-box rounded-md w-[16.6rem] overflow-hidden mb-3"
        [ngClass]="!showCountriesList ? 'h-12' : 'h-[12200px]'"
      >
        <div class="flex box-selected-countries">
          <label for="search-bar"></label>

          <input
            [(ngModel)]="mobileNumber"
            [ngModelOptions]="{ standalone: true }"
            type="text"
            aria-label="search-bar"
            id="search-bar"
            name="search-bar"
            class="bg-white outline-input w-[8.75rem] mr-2 top-1 relative text-sm"
            placeholder="موبایل (بدون صفر اول)"
          />          

          <div
            class="flex scale-90 relative top-1 cursor-pointer"
            dir="ltr"
            (click)="countriesDropDown()"
          >
            <i
              class="scale-6 icon-modal mr-2"
              [ngClass]="!showCountriesList ? 'icon-up' : 'icon-down'"
            ></i>

            <i
              class="w-8 h-6 rounded-md mr-3 relative -top-1 flag fi fi-{{
                countrieIcon | lowercase
              }}"
            ></i>

            <p class="text-black">{{ '(+' + countriePhone + ')' }}</p>
          </div>
        </div>

        <div class="w-[16.6rem]">
          <div
            class="relative flex w-64 mb-4 bg-[bisque] rounded-md h-8 mr-1 mt-2"
          >
            <i
              class="search-icon-white absolute z-10 scale-6 top-1 right-56"
            ></i>

            <label for="search-bar"></label>

            <input
              tabindex="-1"
              (input)="fillSearchValue($any($event.target).value)"
              type="search"
              class="bg-[bisque] outline-input w-52 h-7 mr-2 top-1 relative text-sm"
              dir="ltr"
              name="search-bar"
              id="search-bar"
              aria-label="search-bar"
              placeholder="search-country"
            />
          </div>

          <ng-container *ngFor="let item of countries | serchFilter : search">
            <div
              class="flex countries-row"
              (click)="countriesSelected(item.code, item.phone)"
            >
              <i
                class="w-8 h-6 rounded-md mr-3 relative -top-1 flag fi fi-{{
                  item.code | lowercase
                }}"
              ></i>

              <p class="text-black mr-2">{{ item.name }}</p>
              <p class="text-black">{{ '(+' + item.phone + ')' }}</p>
            </div>
          </ng-container>
        </div>
      </div>

<!-- ==========[نحوه آشنایی]======== -->
<div
  class="flex drop-down flex-col overflow-hidden w-[268px] max-w-[287px]"
  [ngClass]="!dropDown ? 'h-[110px]' : 'h-12'"
>
  <!-- عنوان -->
  <div
    class="flex items-center justify-between mt-1 cursor-pointer"
    (click)="toggleDropDown()"
  >
    <p>
      نحوه آشنایی با ما<span *ngIf="knowType != null"> : {{ wayKnowTypeName }}</span>
    </p>

    <i
      class="icon-modal"
      [ngClass]="!dropDown ? 'icon-up' : 'icon-down'"
    ></i>
  </div>

  <!-- گزینه‌ها -->
  <div
    class="flex items-center justify-between gap-1 mb-3 mt-4 w-[250px] max-w-[287px]"
  >
    <ng-container *ngFor="let item of wayKnowType; let i = index">
      <div
        class="flex flex-col items-center justify-center cursor-pointer hover:opacity-100 min-w-0"
        [ngClass]="knowType == item.id ? 'opacity-100' : 'opacity-25'"
        (click)="toggle(i, item.label, item.icon)"
      >
        <img
          loading="lazy"
          [src]="item.icon"
          alt="icon-modal"
          class="w-5 h-5"
        />

        <p class="mt-1 text-[10px] text-black whitespace-nowrap">
          {{ item.label }}
        </p>
      </div>
    </ng-container>
  </div>
</div>

<!-- کد معرف -->
<ng-container *ngIf="showParentForm">
  <label for="parentReferralCode"></label>

  <input
    (input)="fillParentValue($any($event.target).value)"
    id="parentReferralCode"
    autocomplete="off"
    class="bg-white outline-input my-3 relative h-11 pr-2 pl-3 py-2 text-sm border-input-box rounded-md w-[16.6rem] overflow-hidden"
    aria-label="submit-data"
    placeholder="کد معرف"
  />
</ng-container>
      <ng-container *ngIf="activeError1">
        <p class="text-red-700 md:text-base text-sm w-56 mt-3">
          لطفا نحوه آشنایی با ما را مشخص کنید
        </p>
      </ng-container>

      <ng-container *ngIf="activeError2">
        <p class="text-red-700 md:text-base text-sm w-56 mt-3">
          لطفا شماره موبایل را وارد کنید
        </p>
      </ng-container>
    </div>

    <!-- ==========[OTP]======== -->
    <ng-container *ngIf="otpStep">
      <div class="registration-otp-box col-span-2">
    
        <p class="registration-otp-title">
          کد تایید ارسال شده به شماره موبایل را وارد کنید
        </p>
    
        <div class="registration-otp-action-row">
    
          <input
            [(ngModel)]="registrationOtpCode"
            [ngModelOptions]="{ standalone: true }"
            type="text"
            inputmode="numeric"
            maxlength="4"
            autocomplete="one-time-code"
            aria-label="کد تایید"
            class="registration-otp-input"
            placeholder="----"
          />
    
          <button
            type="button"
            class="registration-otp-button"
            [disabled]="otpVerifying || registrationOtpCode.length !== 4"
            (click)="verifyRegistrationOTP()"
          >
            {{ otpVerifying ? 'در حال بررسی...' : 'تایید کد' }}
          </button>
    
        </div>
    
        <div class="registration-otp-resend">
    
          <ng-container *ngIf="otpCooldown > 0">
            <span class="registration-otp-cooldown-icon">↻</span>
            <span>ارسال مجدد کد</span>
            <strong>{{ otpCooldown }}</strong>
            <span>ثانیه دیگر</span>
          </ng-container>
    
          <button
            *ngIf="otpCooldown === 0"
            type="button"
            [disabled]="otpSending"
            (click)="sendRegistrationOTP()"
          >
            {{ otpSending ? 'در حال ارسال...' : 'ارسال مجدد کد تایید' }}
          </button>
    
        </div>
    
        <button
          type="button"
          class="registration-otp-back"
          [disabled]="otpSending || otpVerifying"
          (click)="backToRegistrationForm()"
        >
          تغییر شماره / بازگشت
        </button>
    
      </div>
    </ng-container>
    
    <!-- ==========[ثبت نام]======== -->
    <button
      *ngIf="!otpStep"
      class="button-submit rounded-lg text-white font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 col-span-2"
      type="submit"
      aria-label="عضویت"
      name="sign-in"
      [disabled]="loading"
    >
      {{ loading ? 'در حال ارسال کد...' : 'عضویت' }}
    </button>
  </div>
</form>

<p class="text-small font-black text-black mt-2 text-center">
  حساب کاربری دارید؟

  <button
    type="button"
    name="login"
    aria-label="لاگین"
    (click)="changeView.emit(true)"
    class="text-blue-800 p-0 m-0 bg-transparent cursor-pointer"
  >
    وارد شوید
  </button>
</p>